import { React, useEffect, useState } from "react";
import "./WeeklySchedule.css";
import {
  Col,
  DatePicker,
  Row,
  Button,
  Spin,
  Form,
  Checkbox,

  Table,
  Tag,
} from "antd";
import ButtonComp from "../../ButtonComp/ButtonComp";
import { CheckCircleFilled } from "../../../Utils/imports";
import SyncMachine from "../SyncMachine/SyncMachine";
import { useDispatch, useSelector } from 'react-redux';

const WeeklySchedule = () => {

  const { current } = useSelector(state => state?.plant)
  const [selectedMachines, setSelectedMachines] = useState([]);
  const machineShift = current?.line?.shifts;
  const [machineShiftState, setMachineShiftState] = useState(current?.line?.shifts || []);
  const sync = async () => {};
  // console.log(machineShift)
  // const machineShift = machine ? machine?.shifts : line?.shifts
  const updatedMachineShift = machineShift.map((x) => {
    if (x.weeklySchedule == null) {
      return {
        ...x, 
        weeklySchedule: {
          'Monday': true,
          'Tuesday': true,
          'Wednesday': true,
          'Thursday': true,
          'Friday': true,
          'Saturday': true,
          'Sunday': true
        }
      };
    }
    return x; 
  });
  
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

//   const formattedDataSource = line?.shifts;

const handleCheckboxChange = (record, day) => {
  const updatedMachineShift = machineShiftState.map((x) => {
    if (x.name === record.name) {
      const updatedWeeklySchedule = { ...x.weeklySchedule };
      updatedWeeklySchedule[day] = !updatedWeeklySchedule[day];
      return { ...x, weeklySchedule: updatedWeeklySchedule };
    }
    return x;
  });


  console.log("Updated Machine Shift", updatedMachineShift);
  console.log("Record", record);
  console.log("Day", day);

  setMachineShiftState(updatedMachineShift);
};




const columns = days.map((day) => ({
  title: day,
  dataIndex: 'name',
  key: day.toLowerCase(),
  render: (text, record) => (
    <>
      <Checkbox
        checked={record.weeklySchedule[day]}
        onChange={() =>
          {
            record.weeklySchedule[day] = !record.weeklySchedule[day]
             handleCheckboxChange(record, day)
            }
        }>
      {record.name}
      </Checkbox>
    </>
  ),
}));

const updateSchedule = () =>{
  console.log(updatedMachineShift);
  const { dispatch, currentShift, machine, plant, line, currentUser } = current;
  let data = {}
  let detailsAfter = []
  if (machine) {
    line.machines.map(x => {
      if (x.machineName == machine.machineName){
        x.shifts = machineShift
        
        // detailsAfter = detailsAfter.push({ shiftName : x.name , weeklySchedule : x.weeklySchedule })
      }
    })
    data = {
      'machines': line?.machines
    }
  }
  else {
    data = {
      shifts: machineShift,
    }
    // detailsAfter = detailsAfter.push({ shiftName : x.name , weeklySchedule : x.weeklySchedule })
  }
  // const log = this.generateLog({productionLine, plant, machine, currentUser, detailsAfter:{...data.shifts},action:'schedule'})
  // dispatch({
  //   endpoint: productionLine.update,
  //   payload: {
  //     id: line.id,
  //     data,
  //     log
  //   },
  // });
  // emailOnLineSettingsChange({
  //   productionLine: line,
  //   type: 'weekly-schedule-change',
  //   currentShift,
  //   machine: machine ? machine.machineName : null,
  // })

}

  return (
    <>
      <Row gutter={24} className="pt1">
        <Col span={12} className="dflex">
          <h1 className="pageHead">Weekly Schedule</h1>
        </Col>
        <Col span={12} style={{ paddingTop: "3px" }}>
          <div className="width100P dflex alignCenter justifyFE">
            <ButtonComp
              htmlType="submit"
              theme="blue"
              icon={<CheckCircleFilled />}
              text="Save"
              onClick={updateSchedule}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form>
            <Table
              rowKey={(record) => {
                return JSON.stringify(record);
              }}
              className="formulaTable"
              columns={columns}
              dataSource={updatedMachineShift}
              checkbox={true}
              pagination={false}
            />
          </Form>
        </Col>
      </Row>
      <Row className="width100P">
        <Col span={24}>
          <Form>
            <SyncMachine
              machine={current?.machine}
              //  canSync={(x) => canSync(x)}
              selectedMachines={selectedMachines}
              sync={sync}
              productionLine={current?.line?.productionLine}
              changeMachines={(machines) => {
                setSelectedMachines(machines);
              }}
            />
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default WeeklySchedule;
